// deps
import React, { memo, ReactElement } from "react";

// styles
import { Tick as StyledTick, TickContainer, TickIcon, TickSvg } from "./styles/Tick.styled";

export enum TICK_ACCENT {
    ORANGE = "ORANGE",
    GREEN = "GREEN",
}

export interface TickProps {
    selected: boolean;
    className?: string;
    accent?: TICK_ACCENT;
    "data-testid"?: string;
}

const TickSvgComponent = memo(function TickSvgComponent(): ReactElement {
    return (
        <TickSvg width="10" height="9" fill="none" viewBox="0 0 10 9">
            <path stroke="#fff" strokeWidth="2" d="M1 4.429L4.112 7 9 1"></path>
        </TickSvg>
    );
});

function Tick(props: TickProps): ReactElement {
    const { accent = TICK_ACCENT.GREEN } = props;

    return (
        <StyledTick
            className={props.className}
            data-testid={props["data-testid"]}
            aria-checked={props.selected}
            role="checkbox"
            tabIndex={0}
        >
            <TickContainer $selected={props.selected} $accent={accent}>
                <TickIcon>
                    <TickSvgComponent />
                </TickIcon>
            </TickContainer>
        </StyledTick>
    );
}

export default memo<TickProps>(Tick);
